import Card from './Card';
import Carousel from '../../Carousel';
import { useState, useCallback } from 'react';
import { Button, CircularProgress, makeStyles, useMediaQuery } from '@material-ui/core';
import * as inviteService from 'services/invites';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { setInviteList } from 'redux/showcaseInvite/slice';
import { fetchShelves } from 'redux/showcase/slice';

const useStyles = makeStyles((theme) => ({
  loading: {
    animation: 'none !important',
    padding: theme.spacing(0, 6, 4, 0),
  },
  button: {
    color: theme.palette.grey[400],
    textTransform: 'lowercase',
    fontSize: 14,
    padding: theme.spacing(0, 2),
    marginLeft: theme.spacing(2),
  },
}));

const InviteShelf = () => {
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const isSmallScreen = useMediaQuery('@media(max-width: 375px)');
  const dispatch = useAppDispatch();
  const invites = useAppSelector((state) => state.showcaseInvite.list);

  const fetchInviteList = useCallback(() => {
    setLoading(true);
    inviteService
      .fetchInvites()
      .then((list) => dispatch(setInviteList(list)))
      .finally(() => setLoading(false));
  }, []);

  const acceptInvite = (hash: string) => () => {
    setLoading(true);
    return inviteService
      .acceptInvite(hash)
      .then(() => inviteService.fetchInvites().then((list) => dispatch(setInviteList(list))))
      .then(() => dispatch(fetchShelves()))
      .finally(() => setLoading(false));
  };

  const refuseInvite = (hash: string) => () => {
    setLoading(true);
    return inviteService
      .refuseInvite(hash)
      .then(() => inviteService.fetchInvites().then((list) => dispatch(setInviteList(list))))
      .finally(() => setLoading(false));
  };

  const handleAcceptAllInvites = () => {
    inviteService.acceptAllInvites().then(fetchInviteList);
  };

  return (
    <div>
      <Carousel
        id='showcase-shelf-invites'
        title={
          <>
            {isSmallScreen && invites.length > 1 ? 'Convites' : 'Convites pendentes'}
            {invites.length > 1 && !loading && (
              <Button variant='text' className={classes.button} onClick={handleAcceptAllInvites}>
                {loading && <CircularProgress size={8} classes={{ root: classes.loading }} />}
                Aceitar tudo
              </Button>
            )}
          </>
        }
        isEmpty={(invites ?? []).length === 0}
        loadingShelf={loading}
        hasMoreContentToFetch={false}
      >
        {(invites ?? []).map((invite) => (
          <Card key={invite.id} {...invite} accept={acceptInvite(invite.hash)} refuse={refuseInvite(invite.hash)} />
        ))}
      </Carousel>
    </div>
  );
};

export default InviteShelf;
